import { render, staticRenderFns } from "./informacionCliente.vue?vue&type=template&id=52357ec9"
import script from "./informacionCliente.vue?vue&type=script&lang=js"
export * from "./informacionCliente.vue?vue&type=script&lang=js"
import style0 from "./informacionCliente.vue?vue&type=style&index=0&id=52357ec9&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports